import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Menu, MenuLoopSpecialDateCreate } from "client/jspPlatformExperiment";

interface NewSpecialDateInfo {
  targetMenuLoopId: number;
  newSpecialDateCreate: MenuLoopSpecialDateCreate;
}

interface MenuDetailStateProps {
  /** Return value of menu data from the Jasper Platform API call */
  menu: Menu | null;
  /** Special date information for the menu if the menu is created for a special meal*/
  specialDateInfo: NewSpecialDateInfo | null;
}

const initialState: MenuDetailStateProps = {
  menu: null,
  specialDateInfo: null,
};

export const menuDetailSlice = createSlice({
  name: "menuDetailSlice",
  initialState,
  reducers: {
    setMenuDetail: (state, action: PayloadAction<Menu | null>) => {
      return { ...state, menu: action.payload };
    },
    setSpecialDateInfo: (
      state,
      action: PayloadAction<NewSpecialDateInfo | null>,
    ) => {
      return { ...state, specialDateInfo: action.payload };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const menuDetailActions = {
  ...menuDetailSlice.actions,
};

const menuDetailSliceReducer = menuDetailSlice.reducer;

export default menuDetailSliceReducer;
